import { render, staticRenderFns } from "./ActiveAlertBanner.vue?vue&type=template&id=bf85d1ba&"
import script from "./ActiveAlertBanner.vue?vue&type=script&lang=js&"
export * from "./ActiveAlertBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports